module.exports = __webpack_public_path__ + "img/airbase-hotspot-1.4.0edddee2.png";